import { render } from "./tpl_top_two_bottom_one.vue?vue&type=template&id=1c773f1a&scoped=true"
import script from "./tpl_top_two_bottom_one.vue?vue&type=script&lang=js"
export * from "./tpl_top_two_bottom_one.vue?vue&type=script&lang=js"

import "./tpl_top_two_bottom_one.vue?vue&type=style&index=0&id=1c773f1a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c773f1a"],['__file',"src/views/dragger/template/tpl_top_two_bottom_one.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c773f1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c773f1a', __exports__)) {
    console.log('reload')
    api.reload('1c773f1a', __exports__)
  }
  
  module.hot.accept("./tpl_top_two_bottom_one.vue?vue&type=template&id=1c773f1a&scoped=true", () => {
    console.log('re-render')
    api.rerender('1c773f1a', render)
  })

}


export default __exports__